<div mat-dialog-content class="flex flex-col">
  <div class="flex flex-row gap-4 mb-4">
    <mat-icon>edit</mat-icon>
    <span class="text-lg font-semibold">Edit User</span>
  </div>

  <div *ngIf="processing">
    <h2>Loading...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading content">
    </mat-progress-bar>
  </div>

  <mat-card *ngIf="user != null">
    <mat-card-title>{{user?.fullName}} ({{user?.userName}})</mat-card-title>
    <mat-card-content>
      <div class="flex flex-col">
        <div class="flex flex-col md:flex-row md:gap-4" *ngIf="user?.address != null && user?.address.length > 0">
          <span class="font-semibold">Address:</span>
          <span>{{user?.address}} {{user?.city}} {{user?.state}} {{user?.zip}}</span>
        </div>

        <div class="flex flex-col md:flex-row md:gap-4" *ngIf="user?.mobile != null && user?.mobile.length > 0">
          <span class="font-semibold">Mobile:</span>
          <span>{{user?.mobile}}</span>
        </div>

        <div class="flex flex-col md:flex-row md:gap-4"  *ngIf="user?.phone != null && user?.phone.length > 0">
          <span class="font-semibold">Phone:</span>
          <span>{{user?.phone}}</span>
        </div>

        <div class="flex flex-col md:flex-row md:gap-4"  *ngIf="user?.jobTitle != null && user?.jobTitle.length > 0">
          <span class="font-semibold">Title:</span>
          <span>{{user?.jobTitle}}</span>
        </div>

        <div class="flex flex-col gap-4">
          <span class="font-semibold">Roles:</span>
          <span *ngFor="let role of roles">
            <mat-checkbox (change)="updateUserRole(role, $event)" [checked]="userHasRole(role)">{{role}}</mat-checkbox><br />
          </span>
        </div>
      </div>

      <div class="flex flex-col md:flex-row md:gap-4 pt-4">
        <button mat-button color="primary" (click)="saveUser()" [disabled]="processing || user == null" color="primary">Save User</button>
        <button mat-button color="warn" mat-dialog-close="Cancel" aria-label="Cancel">Cancel</button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
